// extracted by mini-css-extract-plugin
export default {"specialties":"specialties_specialties__YcACi"};